import { Card, OrderLineItem } from 'corso-admin-ui';
import { useCurrency } from '~/hooks/useCurrency';
import { useProduct } from '~/features/products/ProductProvider';

export function ProductVariantList() {
  const { variants } = useProduct();
  const { currencyCode } = useCurrency();

  if (!variants.length) return null;

  return (
    <Card>
      <Card.Line>
        <Card.Heading>Variants</Card.Heading>
      </Card.Line>

      {variants.map((variant) => (
        <div
          className="flex items-center justify-between gap-2"
          key={variant.id}
        >
          <div className="flex-1">
            <OrderLineItem
              size="sm"
              src={variant.imgUrl}
              title={variant.optionsValueString || variant.titleWithOptions}
              sku={variant.sku}
              price={{ currencyCode, unitPrice: variant.price }}
            />
          </div>
        </div>
      ))}
    </Card>
  );
}
